export default __webpack_public_path__ + "static/media/avatar16.04f60b25.png";